import React, { ChangeEvent, useState } from 'react';
import Modal from '../../../components/Modal/Modal';
import messages from './messages';
import Input from '../../../components/Input/Input';
import { black, white } from '../../../utils/style/colors';
import Button from '../../../components/Button/Button';
import { ContentContainer } from '../../LoginPage/LoginCard/styles';
import Icon from '../../../components/Icon';
import { toPng } from 'html-to-image';
import { getBlob } from '../../../utils/file';
import {
  ISurveyItem,
  ISurveyResponseView,
} from '../../../store/survey/surveyTypes';
import { IDocumentView } from '../../../store/companies/companiesTypes';
import { addResponse } from '../../../store/survey/surveySlice';
import { appDispatch } from '../../../store/store';
import notify from '../../../components/Notify';
import heic2any from 'heic2any';

const convertHeicToJpg = async (file: File) => {
  try {
    const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
    return new File(
      [convertedBlob as Blob],
      file.name.replace('.heic', '.jpg'),
      { type: 'image/jpeg' }
    );
  } catch (error) {
    console.error('HEIC conversion failed:', error);
    return null;
  }
};

export function CampaignImage(props: {
  onClose: () => void;
  active: boolean;
  surveyItem: ISurveyItem;
}) {
  const [fullName, setFullName] = useState('');
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
  const [alreadySharedToPublic, setAlreadySharedToPublic] = useState(false);
  const convasRef: React.RefObject<HTMLDivElement> = React.createRef();
  const imageRef: React.RefObject<HTMLImageElement> = React.createRef();
  const [sendingImage, setSendingImage] = useState(false);
  const buildPng = async (node: HTMLElement, width: number) => {
    let dataUrl = '';
    let i = 0;
    const maxAttempts = isSafari() ? 3 : 1;
    while (i < maxAttempts) {
      const condid = await toPng(node, {
        canvasWidth: width,
        width: width,
      });
      if (condid.length > dataUrl.length) dataUrl = condid;
      i += 1;
    }
    return dataUrl;
  };

  const saveResponse = async (dataUrl: string) => {
    const response: ISurveyResponseView = {
      draft: false,
      instance: props.surveyItem.instance,
      surveyId: props.surveyItem.surveyId,
      surveyAnswerList: [
        { type: 'text', value: fullName, questionId: 839199354918099 },
        {
          type: 'file',
          file: {
            url: dataUrl,
            fileSize: dataUrl.length,
            uploading: true,
            properties: {
              format: 'image/png',
              displayName: (fullName || '_image') + '.png',
            },
          } as IDocumentView,
          questionId: 688469431752288,
        },
      ],
      effectiveDate: new Date().valueOf(),
      surveyVersion: undefined as any,
      extraInfo: {
        itemId: props.surveyItem.id,
        providerId: props.surveyItem.providerId,
      },
    };
    appDispatch(
      addResponse({
        response,
        surveyItemData: props.surveyItem,
        periodType: 'none',
      })
    ).then(() => {
      setAlreadySharedToPublic(true);
    });
  };

  const saveImage = () => {
    setSendingImage(true);
    if (!alreadySharedToPublic) {
      buildPng(convasRef.current!, 360).then(async (dataUrl) => {
        saveResponse(dataUrl).then(() => {
          notify(messages.imageSent);
          setSendingImage(false);
        });
      });
    } else {
      notify(messages.alreadySent);
    }
  };

  const shareImage = (download = false) => {
    buildPng(convasRef.current!, 360)
      .then(async (dataUrl) => {
        const pngImageBlob = await getBlob(dataUrl);
        const file = new File([pngImageBlob], 'nabetasadof.png', {
          type: pngImageBlob.type,
        });
        if (!download) {
          try {
            await navigator.share({
              title: '#نه_به_تصادف',
              url: 'https://nabetasadof.ir/',
              files: [file],
            });
          } catch (error) {
            /* ignored */
          }
        } else {
          const blobUrl = URL.createObjectURL(pngImageBlob);

          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = 'nabetasadof'; // Set the filename
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch(function () {
        /*do nothing*/
      });
  };

  const handleAddPiture = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (!file) return;

    let finalFile = file;

    if (file.type === 'image/heic' || file.name.endsWith('.heic')) {
      finalFile = (await convertHeicToJpg(file)) as File;
    }

    if (finalFile) {
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedImage(reader.result as string);
      };
      reader.readAsDataURL(finalFile);
    }
  };

  return (
    <Modal
      title={messages.ImContributor}
      onClose={props.onClose}
      width="381px"
      isActive={props.active}
      key="contributon"
    >
      <div className={'flex flex-col gap-5'}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Input
            label={messages.fullName}
            type={'text'}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setFullName(e.target.value)
            }
            value={fullName}
            id={'FullName'}
            wrapperStyle={{ width: '50%' }}
          />
          <input
            type="file"
            id="file-upload"
            accept="image/*"
            onChange={handleAddPiture}
            style={{ display: 'none' }}
            required={true}
          />

          <label
            htmlFor="file-upload"
            style={{
              padding: '0.5rem 0.25rem',
              marginTop: '0.25rem',
              backgroundColor: `${black}`,
              color: 'white',
              borderRadius: '10px',
              cursor: 'pointer',
              display: 'inline-block',
              alignSelf: 'flex-end',
              marginBottom: '7px',
            }}
          >
            <Icon type={'image'} color={white} /> {messages.chooseFile}
          </label>
        </div>

        {uploadedImage && fullName && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }}
          >
            {navigator.canShare &&
              navigator.canShare({
                files: [new File([], 'test.png', { type: 'image/png' })],
              }) && (
                <Button
                  color={'blue'}
                  disabled={false}
                  onClick={() => shareImage()}
                >
                  <Icon type={'share'} /> {messages.share}
                </Button>
              )}
            <Button
              color={'green'}
              disabled={false}
              onClick={() => shareImage(true)}
            >
              <Icon type={'download'} />
              {messages.download}
            </Button>
            <Button
              color={'white'}
              disabled={false}
              onClick={() => saveImage()}
              loading={sendingImage}
            >
              <Icon type={'send'} />
              {messages.shareToPublic}
            </Button>
          </div>
        )}
        {
          <div
            style={{
              display: 'block',
              margin: 'auto',
              position: 'relative',
              width: '360px',
              height: '640px',
            }}
            ref={convasRef}
          >
            <img
              decoding="sync"
              src="/assets/Story-campaign-name-template.png"
              alt="Template"
              style={{ width: '100%', display: 'block' }}
            />

            {uploadedImage && (
              <div ref={imageRef}>
                <img
                  decoding="sync"
                  src={uploadedImage}
                  alt="Uploaded"
                  style={{
                    position: 'absolute',
                    top: '100px',
                    left: '110px',
                    width: '143px',
                    height: '143px',
                    objectFit: 'cover',
                    borderRadius: '12px',
                  }}
                />
              </div>
            )}
            <ContentContainer>
              <h4 style={{ whiteSpace: 'pre-line', lineHeight: '1.3rem' }}>
                {`${messages.getCampaignMessage(fullName)}`}
              </h4>
              <h3 style={{ whiteSpace: 'pre-line' }}>
                {`${messages.getCampaignMessage2}`}
              </h3>
            </ContentContainer>
          </div>
        }
      </div>
    </Modal>
  );
}
